/**
 * Получить число из форматированной строки
 * @param value Строка
 */
export const parseFormattedNumber = (value: string, localeCode: string): number | null => {
    if (value === null || value === undefined || value === '') {
        return null;
    }

    if (!isNaN(Number(value))) {
        return Number(value);
    }

    const separator = getNumberSeparator(localeCode);
    const cleanedNumber = value
        .replace(/\s+/g, '')
        .replace(new RegExp(`\\${separator.group}`, 'g'), '')
        .replace(new RegExp(`\\${separator.decimal}`, 'g'), '.');

    const result = Number(cleanedNumber);
    return isNaN(result) ? null : result;
};

/**
 * Получить разделители для числа
 */
export const getNumberSeparator = (localeCode: string) => {
    const numberFormat = new Intl.NumberFormat(localeCode);
    const parts = numberFormat.formatToParts(12345.67);
    const decimal = parts.find((part) => part.type === 'decimal')?.value || '.';
    const group = parts.find((part) => part.type === 'group')?.value || ',';

    return {
        decimal,
        group,
    };
};

/**
 * Получить точность числа
 * @param value Число
 * @param localeCode Код локали
 */
export const getPrecision = (value: string, localeCode: string): number => {
    const separator = getNumberSeparator(localeCode);
    if (!value.includes(separator.decimal)) {
        return 0;
    }

    return value.trim().split(separator.decimal)[1].length;
};

/**
 * Форматирует число в строку, добавляя недостающие десятичные знаки.
 *
 * - Если передано не число, возвращает пустую строку.
 * - Если уже есть десятичная часть, дополняет её нулями до указанной точности.
 *
 * @param value - Число.
 * @param precision - Количество знаков после запятой.
 */
export const formatDecimalPrecision = (value: any, precision?: number): string => {
    if (value === undefined || value === null || value === '') {
        return '';
    }

    // В значениях полей всегда используется представление числа с точкой
    value = (value + '').replace(',', '.').replace(' ', '');
    if (isNaN(Number(value))) {
        return '';
    }

    return Number(value).toFixed(precision ?? 2);
};
